import { useEffect, useState } from 'react';

/** true en dessous de 768px (breakpoint `md` de Tailwind). */
export const useIsMobile = (query = '(max-width: 767px)') => {
  const [matches, setMatches] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = (e) => setMatches(e.matches);
    mql.addEventListener('change', onChange);
    setMatches(mql.matches);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
};

export default useIsMobile;
